import { create } from 'zustand';

const KEY = 'asia_onboarded';

const read = (): boolean => {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};

interface OnboardingState {
  /** True once the user has finished onboarding (persisted across launches). */
  onboarded: boolean;
  /** Mark onboarding done — hidden from now on. */
  complete: () => void;
  /** Reset to the very first launch (e.g. "terminate all sessions" = log out). */
  reset: () => void;
}

export const useOnboarding = create<OnboardingState>((set) => ({
  onboarded: read(),
  complete: () => {
    try {
      localStorage.setItem(KEY, '1');
    } catch {
      /* storage unavailable */
    }
    set({ onboarded: true });
  },
  reset: () => {
    try {
      localStorage.removeItem(KEY);
    } catch {
      /* storage unavailable */
    }
    set({ onboarded: false });
  },
}));
